/**
 * Format a persisted `totalTimeMinutes` for DISPLAY as Norwegian hours+minutes,
 * e.g. 90 → "1 time 30 min", 150 → "2 timer 30 min", 25 → "25 min",
 * 60 → "1 time", 2400 → "40 timer". Singular "time" for exactly one hour,
 * "timer" otherwise. Under an hour shows only minutes; whole hours omit "0 min".
 *
 * The recipe editor keeps its OWN split (deriveTimeStrings in RecipeEditorPage)
 * for the two editable input fields; this helper is purely for read-only display
 * (cards, detail view).
 */
export function formatTotalTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins} min`;
  const hourPart = `${hours} ${hours === 1 ? "time" : "timer"}`;
  return mins === 0 ? hourPart : `${hourPart} ${mins} min`;
}
